<template>

    <v-page-section v-if="company.lifetime_deal" padded>
        <template #body>
            <v-alert type="info">Lifetime Deal</v-alert>
        </template>
    </v-page-section>

    <v-page-section v-else-if="company.is_trialing" padded>
        <template #body>
            <v-alert>Your trial ends {{ company.trial_ended_at | relativeTime }}. Please upgrade your plan.</v-alert>
        </template>
    </v-page-section>

    <v-page-section v-else-if="company.customers_limit > 0 && company.customers_count >= company.customers_limit" padded>
        <template #body>
            <v-alert>Customer limit reached. Please upgrade your plan to continue adding customers.</v-alert>
        </template>
    </v-page-section>

    <v-page-section v-else-if="company.monthly_email_limit > 0 && company.monthly_email_count >= company.monthly_email_limit" padded>
        <template #body>
            <v-alert>Monthly email limit reached. Please upgrade your plan to continue sending emails.</v-alert>
        </template>
    </v-page-section>

</template>

<script>

export default {

    props: {
        company: {
            type: Object,
            required: true,
        },
    },

}

</script>